(function () {
  const htmlLang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
  const SUPPORTED_LOCALES = ['en', 'fr', 'es'];
  const LANGUAGE_LABELS = {
    en: 'English',
    de: 'Deutsch',
    fr: 'Français',
    es: 'Español',
    ja: '日本語',
    it: 'Italiano'
  };

  function normalizeLocale(value) {
    if (!value) return null;
    const normalized = String(value).trim().toLowerCase().replace('_', '-');
    const shortCode = normalized.split('-')[0];
    return SUPPORTED_LOCALES.includes(shortCode) ? shortCode : null;
  }

  function detectPathLocale() {
    const match = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
    return match ? normalizeLocale(match[1]) : null;
  }

  const pathLocale = detectPathLocale();

  const translations = {
    de: {
      'CSTAR Fashion Design | Custom Rhinestone Transfers, Patches & Promotional Products': 'CSTAR Fashion Design | Individuelle Rhinestone-Transfers, Patches & Werbeprodukte',
      'Rhinestone & Patch Manufacturing for Repeat B2B Orders': 'Rhinestone-Transfers & Patch-Produktion für wiederkehrende B2B-Bestellungen',
      'UPLOAD ARTWORK & GET A QUOTE': 'DESIGN HOCHLADEN & ANGEBOT ANFORDERN',
      'Rhinestone transfers, embroidered patches, silicone patches, TPU patches, woven labels and leather patches for apparel brands, print shops, schools, teams and promotional buyers. Send artwork, quantity and target date to confirm the right material, MOQ, sample plan and bulk lead time.': 'Rhinestone-Transfers, Stickpatches, Silikonpatches, TPU-Patches, Webetiketten und Lederpatches für Modemarken, Druckereien, Schulen, Teams und Werbeartikel-Einkäufer. Senden Sie Design, Menge und Zieltermin, damit wir Material, MOQ, Musterplan und Produktionszeit bestätigen können.',
      'Built for Buyers Who Need Clear MOQ, Sample and Lead Time': 'Für Einkäufer mit klarem Bedarf an MOQ, Mustern und Lieferzeit',
      'CSTAR focuses on production-ready embellishments for buyers who need repeat orders, clear MOQ, sample guidance and dependable bulk lead time from sampling to shipping.': 'CSTAR konzentriert sich auf produktionsreife Veredelungen für Einkäufer, die Wiederholaufträge, klare MOQ, Musterrichtlinien und verlässliche Produktionszeiten vom Muster bis zum Versand benötigen.',
      'What CSTAR Helps You Source': 'Was CSTAR für Sie beschaffen kann',
      'Main Product Families': 'Wichtige Produktfamilien',
      'Our main custom products include rhinestone heat transfers, embroidered patches, silicone patches, TPU patches, woven labels and leather patches. Selected heat transfer options remain available when they fit the project.': 'Zu unseren Hauptprodukten gehören Rhinestone-Transfers, Stickpatches, Silikonpatches, TPU-Patches, Webetiketten und Lederpatches. Ausgewählte Transferoptionen bleiben verfügbar, wenn sie zum Projekt passen.',
      'Browse core categories': 'Hauptkategorien ansehen',
      'Best-Fit Buyer Profiles': 'Passende Käuferprofile',
      'We mainly support apparel brands, print shops, embroidery factories, promotional product companies, schools, teams and event merch buyers who need repeatable custom production.': 'Wir unterstützen vor allem Modemarken, Druckereien, Stickereien, Werbeartikelunternehmen, Schulen, Teams und Event-Merch-Einkäufer mit wiederholbarer Sonderproduktion.',
      'Tell us what you need': 'Sagen Sie uns, was Sie brauchen',
      'MOQ, Sample & Lead Time Support': 'Unterstützung bei MOQ, Mustern & Lieferzeit',
      'After you send artwork, quantity and target date, we help confirm the right material, MOQ, sample plan, estimated bulk lead time, packaging details and shipping method before production starts.': 'Nach Erhalt von Design, Menge und Zieltermin helfen wir, Material, MOQ, Musterplan, Produktionszeit, Verpackung und Versand vor Produktionsbeginn zu bestätigen.',
      'Upload artwork for quote': 'Design für Angebot hochladen',
      'Real production photos buyers can quote from': 'Echte Produktionsfotos als Angebotsreferenz',
      'Use these real production photos to compare 30+ material and process options before you send artwork. CSTAR will recommend the most suitable process once we see your design, quantity and target delivery date.': 'Nutzen Sie diese echten Produktionsfotos, um über 30 Material- und Prozessoptionen zu vergleichen, bevor Sie Ihr Design senden. CSTAR empfiehlt nach Prüfung von Design, Menge und Zieltermin den passenden Prozess.',
      'Rhinestone Transfers': 'Rhinestone-Transfers',
      'Nailhead & Metallic Stud': 'Nailhead & Metallnieten',
      'Sequin Transfers': 'Pailletten-Transfers',
      'Embroidered Patches': 'Stickpatches',
      'Chenille Patches': 'Chenille-Patches',
      'Silicone Patches': 'Silikonpatches',
      'TPU Patches': 'TPU-Patches',
      'Leather Patches & Labels': 'Lederpatches & Lederlabels',
      'REQUEST SAMPLE PACK': 'MUSTERPAKET ANFORDERN',
      'What to Send for a Faster Quote': 'Was Sie für ein schnelleres Angebot senden sollten',
      'The more production details you provide, the faster we can recommend the right material, MOQ and price range.': 'Je mehr Produktionsdetails Sie angeben, desto schneller können wir Material, MOQ und Preisbereich empfehlen.',
      'How Custom Production Works': 'So läuft die Sonderproduktion ab',
      'Samples Are Free. You Only Pay Shipping.': 'Muster sind kostenlos. Sie zahlen nur den Versand.',
      'Free sample pack': 'Kostenloses Musterpaket',
      '43 sample options': '43 Musteroptionen',
      'Best for B2B buyers': 'Ideal für B2B-Einkäufer',
      'SEND SAMPLE REQUEST': 'MUSTERANFRAGE SENDEN',
      'Submit your sample request': 'Ihre Musteranfrage senden',
      'Get a Production-Ready Custom Quote': 'Produktionsreifes Individualangebot anfordern',
      'START YOUR QUOTE REQUEST': 'ANGEBOTSANFRAGE STARTEN',
      'Send artwork and quote details': 'Design und Angebotsdetails senden',
      'Send artwork, quantity, target delivery date, target price and shipping country. CSTAR will confirm the right material, MOQ, sample options and bulk lead time.': 'Senden Sie Design, Menge, Liefertermin, Zielpreis und Lieferland. CSTAR bestätigt Material, MOQ, Musteroptionen und Produktionszeit.',
      'Need MOQ, Sample and Lead Time Confirmed?': 'MOQ, Muster und Lieferzeit bestätigen lassen?',
      'CSTAR Buyer Download Center': 'CSTAR Download-Center für Einkäufer',
      'PREVIEW ONLINE': 'ONLINE ANSEHEN',
      'DOWNLOAD PDF': 'PDF HERUNTERLADEN',
      'Custom Heat Transfers': 'Individuelle Heat Transfers',
      'Custom Promotional Products': 'Individuelle Werbeprodukte',
      'Printable Transfers': 'Bedruckbare Transfers',
      'Custom DTF Transfers': 'Individuelle DTF-Transfers',
      'Woven Labels, Woven Badges & Brand Trims': 'Webetiketten, Webbadges & Markenzubehör',
      'Leather Patches & Leather Brand Details': 'Lederpatches & Leder-Markendetails',
      'Your Name': 'Ihr Name',
      'Email': 'E-Mail',
      'Phone': 'Telefon',
      'Company Website': 'Unternehmenswebsite',
      'Business Type': 'Geschäftsart',
      'Selected Sample IDs / Sample Types': 'Ausgewählte Muster-IDs / Mustertypen',
      'Your Request': 'Ihre Anfrage',
      'Submit': 'Senden',
      'Subscribe Email': 'E-Mail abonnieren',
      'Enter the sample ID': 'Muster-ID eingeben',
      'Enter name': 'Name eingeben',
      'Enter Email': 'E-Mail eingeben',
      'Enter quantity': 'Menge eingeben',
      'Compare Materials, Finish and MOQ Before You Quote': 'Material, Finish und MOQ vor der Angebotsanfrage vergleichen',
      'Final MOQ and tier pricing depend on material, artwork size, colors and quantity.': 'Endgültige MOQ und Staffelpreise hängen von Material, Designgröße, Farben und Menge ab.'
    },
    fr: {
      'CSTAR Fashion Design | Custom Rhinestone Transfers, Patches & Promotional Products': 'CSTAR Fashion Design | Transferts rhinestones, patchs et produits promotionnels sur mesure',
      'Rhinestone & Patch Manufacturing for Repeat B2B Orders': 'Fabrication de transferts rhinestones et patchs pour commandes B2B récurrentes',
      'UPLOAD ARTWORK & GET A QUOTE': 'ENVOYER LE DESIGN & DEMANDER UN DEVIS',
      'Rhinestone transfers, embroidered patches, silicone patches, TPU patches, woven labels and leather patches for apparel brands, print shops, schools, teams and promotional buyers. Send artwork, quantity and target date to confirm the right material, MOQ, sample plan and bulk lead time.': 'Transferts rhinestones, patchs brodés, patchs silicone, patchs TPU, étiquettes tissées et patchs cuir pour marques de vêtements, imprimeurs, écoles, équipes et acheteurs promotionnels. Envoyez le design, la quantité et la date cible pour confirmer le bon matériau, le MOQ, le plan d’échantillon et le délai de production.',
      'Built for Buyers Who Need Clear MOQ, Sample and Lead Time': 'Conçu pour les acheteurs qui ont besoin d’un MOQ, d’échantillons et de délais clairs',
      'CSTAR focuses on production-ready embellishments for buyers who need repeat orders, clear MOQ, sample guidance and dependable bulk lead time from sampling to shipping.': 'CSTAR se concentre sur des décorations prêtes pour la production, destinées aux acheteurs qui ont besoin de commandes récurrentes, d’un MOQ clair, d’un accompagnement échantillon et d’un délai fiable de la validation à l’expédition.',
      'What CSTAR Helps You Source': 'Ce que CSTAR vous aide à sourcer',
      'Main Product Families': 'Principales familles de produits',
      'Our main custom products include rhinestone heat transfers, embroidered patches, silicone patches, TPU patches, woven labels and leather patches. Selected heat transfer options remain available when they fit the project.': 'Nos principaux produits sur mesure comprennent les transferts rhinestones, patchs brodés, patchs silicone, patchs TPU, étiquettes tissées et patchs cuir. D’autres options de transfert restent disponibles lorsqu’elles conviennent au projet.',
      'Browse core categories': 'Voir les catégories principales',
      'Best-Fit Buyer Profiles': 'Profils d’acheteurs adaptés',
      'We mainly support apparel brands, print shops, embroidery factories, promotional product companies, schools, teams and event merch buyers who need repeatable custom production.': 'Nous accompagnons principalement les marques de vêtements, ateliers d’impression, usines de broderie, sociétés de produits promotionnels, écoles, équipes et acheteurs d’articles événementiels qui ont besoin d’une production sur mesure répétable.',
      'Tell us what you need': 'Dites-nous ce dont vous avez besoin',
      'MOQ, Sample & Lead Time Support': 'Support MOQ, échantillon & délai',
      'After you send artwork, quantity and target date, we help confirm the right material, MOQ, sample plan, estimated bulk lead time, packaging details and shipping method before production starts.': 'Après réception du design, de la quantité et de la date cible, nous aidons à confirmer le matériau adapté, le MOQ, le plan d’échantillon, le délai estimé, l’emballage et le mode d’expédition avant lancement.',
      'Upload artwork for quote': 'Envoyer le design pour devis',
      'Real production photos buyers can quote from': 'Vraies photos de production pour demander un devis',
      'Use these real production photos to compare 30+ material and process options before you send artwork. CSTAR will recommend the most suitable process once we see your design, quantity and target delivery date.': 'Utilisez ces vraies photos de production pour comparer plus de 30 options de matériaux et procédés avant d’envoyer votre design. CSTAR recommandera le procédé le plus adapté après examen du design, de la quantité et de la date cible.',
      'Rhinestone Transfers': 'Transferts rhinestones',
      'Nailhead & Metallic Stud': 'Clous métalliques & nailhead',
      'Sequin Transfers': 'Transferts à sequins',
      'Embroidered Patches': 'Patchs brodés',
      'Chenille Patches': 'Patchs chenille',
      'Silicone Patches': 'Patchs silicone',
      'TPU Patches': 'Patchs TPU',
      'Leather Patches & Labels': 'Patchs & labels en cuir',
      'REQUEST SAMPLE PACK': 'DEMANDER UN KIT D’ÉCHANTILLONS',
      'What to Send for a Faster Quote': 'Que fournir pour obtenir un devis plus rapide',
      'The more production details you provide, the faster we can recommend the right material, MOQ and price range.': 'Plus vous fournissez de détails de production, plus vite nous pouvons recommander le bon matériau, le MOQ et la fourchette de prix.',
      'How Custom Production Works': 'Comment fonctionne la production sur mesure',
      'Samples Are Free. You Only Pay Shipping.': 'Les échantillons sont gratuits. Vous payez uniquement l’expédition.',
      'Free sample pack': 'Kit d’échantillons gratuit',
      '43 sample options': '43 options d’échantillons',
      'Best for B2B buyers': 'Idéal pour les acheteurs B2B',
      'SEND SAMPLE REQUEST': 'ENVOYER UNE DEMANDE D’ÉCHANTILLON',
      'Submit your sample request': 'Envoyer votre demande d’échantillon',
      'Get a Production-Ready Custom Quote': 'Obtenir un devis sur mesure prêt pour la production',
      'START YOUR QUOTE REQUEST': 'COMMENCER VOTRE DEMANDE DE DEVIS',
      'Send artwork and quote details': 'Envoyer le design et les détails du devis',
      'Send artwork, quantity, target delivery date, target price and shipping country. CSTAR will confirm the right material, MOQ, sample options and bulk lead time.': 'Envoyez le design, la quantité, la date de livraison cible, le prix cible et le pays de livraison. CSTAR confirmera le bon matériau, le MOQ, les options d’échantillon et le délai de production.',
      'Need MOQ, Sample and Lead Time Confirmed?': 'Besoin de confirmer le MOQ, l’échantillon et le délai ?',
      'CSTAR Buyer Download Center': 'Centre de téléchargement CSTAR pour acheteurs',
      'PREVIEW ONLINE': 'APERÇU EN LIGNE',
      'DOWNLOAD PDF': 'TÉLÉCHARGER LE PDF',
      'Custom Heat Transfers': 'Transferts thermiques sur mesure',
      'Custom Promotional Products': 'Produits promotionnels sur mesure',
      'Printable Transfers': 'Transferts imprimables',
      'Custom DTF Transfers': 'Transferts DTF sur mesure',
      'Woven Labels, Woven Badges & Brand Trims': 'Étiquettes tissées, badges tissés & accessoires de marque',
      'Leather Patches & Leather Brand Details': 'Patchs cuir & détails de marque en cuir',
      'Your Name': 'Votre nom',
      'Email': 'E-mail',
      'Phone': 'Téléphone',
      'Company Website': 'Site de l’entreprise',
      'Business Type': 'Type d’activité',
      'Selected Sample IDs / Sample Types': 'IDs d’échantillons / types d’échantillons sélectionnés',
      'Your Request': 'Votre demande',
      'Submit': 'Envoyer',
      'Subscribe Email': 'S’abonner par e-mail',
      'Enter the sample ID': 'Saisir l’ID de l’échantillon',
      'Enter name': 'Saisir le nom',
      'Enter Email': 'Saisir l’e-mail',
      'Enter quantity': 'Saisir la quantité',
      'Compare Materials, Finish and MOQ Before You Quote': 'Comparer matériaux, finition et MOQ avant votre devis',
      'Final MOQ and tier pricing depend on material, artwork size, colors and quantity.': 'Le MOQ final et le prix par palier dépendent du matériau, de la taille du design, des couleurs et de la quantité.'
    },
    es: {
      'CSTAR Fashion Design | Custom Rhinestone Transfers, Patches & Promotional Products': 'CSTAR Fashion Design | Transfers de rhinestones, parches y productos promocionales personalizados',
      'Rhinestone & Patch Manufacturing for Repeat B2B Orders': 'Fabricación de transfers de rhinestones y parches para pedidos B2B recurrentes',
      'UPLOAD ARTWORK & GET A QUOTE': 'SUBIR DISEÑO Y SOLICITAR COTIZACIÓN',
      'Rhinestone transfers, embroidered patches, silicone patches, TPU patches, woven labels and leather patches for apparel brands, print shops, schools, teams and promotional buyers. Send artwork, quantity and target date to confirm the right material, MOQ, sample plan and bulk lead time.': 'Transfers de rhinestones, parches bordados, parches de silicona, parches de TPU, etiquetas tejidas y parches de cuero para marcas de ropa, imprentas, escuelas, equipos y compradores promocionales. Envíe el diseño, la cantidad y la fecha objetivo para confirmar el material adecuado, MOQ, plan de muestra y plazo de producción.',
      'Built for Buyers Who Need Clear MOQ, Sample and Lead Time': 'Pensado para compradores que necesitan MOQ, muestras y plazos claros',
      'CSTAR focuses on production-ready embellishments for buyers who need repeat orders, clear MOQ, sample guidance and dependable bulk lead time from sampling to shipping.': 'CSTAR se centra en acabados listos para producción para compradores que necesitan pedidos repetidos, MOQ claros, orientación de muestras y un plazo confiable desde la aprobación hasta el envío.',
      'What CSTAR Helps You Source': 'Lo que CSTAR le ayuda a abastecer',
      'Main Product Families': 'Familias principales de productos',
      'Our main custom products include rhinestone heat transfers, embroidered patches, silicone patches, TPU patches, woven labels and leather patches. Selected heat transfer options remain available when they fit the project.': 'Nuestros productos principales incluyen transfers de rhinestones, parches bordados, parches de silicona, parches de TPU, etiquetas tejidas y parches de cuero. Otras opciones de transferencia siguen disponibles cuando se ajustan al proyecto.',
      'Browse core categories': 'Ver categorías principales',
      'Best-Fit Buyer Profiles': 'Perfiles de comprador más adecuados',
      'We mainly support apparel brands, print shops, embroidery factories, promotional product companies, schools, teams and event merch buyers who need repeatable custom production.': 'Apoyamos principalmente a marcas de ropa, imprentas, fábricas de bordado, empresas de productos promocionales, escuelas, equipos y compradores de merchandising para eventos que necesitan producción personalizada repetible.',
      'Tell us what you need': 'Cuéntenos lo que necesita',
      'MOQ, Sample & Lead Time Support': 'Soporte de MOQ, muestras y plazo',
      'After you send artwork, quantity and target date, we help confirm the right material, MOQ, sample plan, estimated bulk lead time, packaging details and shipping method before production starts.': 'Después de recibir el diseño, la cantidad y la fecha objetivo, ayudamos a confirmar el material adecuado, MOQ, plan de muestra, plazo estimado, embalaje y método de envío antes de iniciar producción.',
      'Upload artwork for quote': 'Subir diseño para cotización',
      'Real production photos buyers can quote from': 'Fotos reales de producción para cotizar',
      'Use these real production photos to compare 30+ material and process options before you send artwork. CSTAR will recommend the most suitable process once we see your design, quantity and target delivery date.': 'Use estas fotos reales de producción para comparar más de 30 opciones de materiales y procesos antes de enviar su diseño. CSTAR recomendará el proceso más adecuado después de revisar el diseño, la cantidad y la fecha objetivo.',
      'Rhinestone Transfers': 'Transfers de rhinestones',
      'Nailhead & Metallic Stud': 'Nailhead y tachas metálicas',
      'Sequin Transfers': 'Transfers de lentejuelas',
      'Embroidered Patches': 'Parches bordados',
      'Chenille Patches': 'Parches chenille',
      'Silicone Patches': 'Parches de silicona',
      'TPU Patches': 'Parches de TPU',
      'Leather Patches & Labels': 'Parches y etiquetas de cuero',
      'REQUEST SAMPLE PACK': 'SOLICITAR PAQUETE DE MUESTRAS',
      'What to Send for a Faster Quote': 'Qué enviar para una cotización más rápida',
      'The more production details you provide, the faster we can recommend the right material, MOQ and price range.': 'Cuantos más detalles de producción proporcione, más rápido podremos recomendar el material correcto, MOQ y rango de precio.',
      'How Custom Production Works': 'Cómo funciona la producción personalizada',
      'Samples Are Free. You Only Pay Shipping.': 'Las muestras son gratis. Solo paga el envío.',
      'Free sample pack': 'Paquete de muestras gratis',
      '43 sample options': '43 opciones de muestra',
      'Best for B2B buyers': 'Ideal para compradores B2B',
      'SEND SAMPLE REQUEST': 'ENVIAR SOLICITUD DE MUESTRA',
      'Submit your sample request': 'Enviar su solicitud de muestra',
      'Get a Production-Ready Custom Quote': 'Obtener una cotización personalizada lista para producción',
      'START YOUR QUOTE REQUEST': 'INICIAR SOLICITUD DE COTIZACIÓN',
      'Send artwork and quote details': 'Enviar diseño y detalles de cotización',
      'Send artwork, quantity, target delivery date, target price and shipping country. CSTAR will confirm the right material, MOQ, sample options and bulk lead time.': 'Envíe el diseño, la cantidad, la fecha de entrega objetivo, el precio objetivo y el país de envío. CSTAR confirmará el material correcto, MOQ, opciones de muestra y plazo de producción.',
      'Need MOQ, Sample and Lead Time Confirmed?': '¿Necesita confirmar MOQ, muestra y plazo de entrega?',
      'CSTAR Buyer Download Center': 'Centro de descargas CSTAR para compradores',
      'PREVIEW ONLINE': 'VER EN LÍNEA',
      'DOWNLOAD PDF': 'DESCARGAR PDF',
      'Custom Heat Transfers': 'Transfers térmicos personalizados',
      'Custom Promotional Products': 'Productos promocionales personalizados',
      'Printable Transfers': 'Transfers imprimibles',
      'Custom DTF Transfers': 'Transfers DTF personalizados',
      'Woven Labels, Woven Badges & Brand Trims': 'Etiquetas tejidas, insignias tejidas y accesorios de marca',
      'Leather Patches & Leather Brand Details': 'Parches de cuero y detalles de marca en cuero',
      'Your Name': 'Su nombre',
      'Email': 'Correo electrónico',
      'Phone': 'Teléfono',
      'Company Website': 'Sitio web de la empresa',
      'Business Type': 'Tipo de negocio',
      'Selected Sample IDs / Sample Types': 'IDs de muestra / tipos de muestra seleccionados',
      'Your Request': 'Su solicitud',
      'Submit': 'Enviar',
      'Subscribe Email': 'Suscribirse por correo',
      'Enter the sample ID': 'Introduzca el ID de muestra',
      'Enter name': 'Introduzca el nombre',
      'Enter Email': 'Introduzca el correo',
      'Enter quantity': 'Introduzca la cantidad',
      'Compare Materials, Finish and MOQ Before You Quote': 'Compare materiales, acabado y MOQ antes de cotizar',
      'Final MOQ and tier pricing depend on material, artwork size, colors and quantity.': 'El MOQ final y el precio escalonado dependen del material, el tamaño del diseño, los colores y la cantidad.'
    },
    ja: {
      'CSTAR Fashion Design | Custom Rhinestone Transfers, Patches & Promotional Products': 'CSTAR Fashion Design | カスタムラインストーン転写・パッチ・販促品',
      'Rhinestone & Patch Manufacturing for Repeat B2B Orders': '継続的なB2B注文向け ラインストーン転写・パッチ製造',
      'UPLOAD ARTWORK & GET A QUOTE': 'デザインを送って見積依頼',
      'Built for Buyers Who Need Clear MOQ, Sample and Lead Time': 'MOQ・サンプル・納期を明確にしたいバイヤー向け',
      'What CSTAR Helps You Source': 'CSTARがご提案できる主な商品',
      'Real production photos buyers can quote from': '見積判断に使える実際の生産写真',
      'What to Send for a Faster Quote': '見積を早くするために必要な情報',
      'How Custom Production Works': 'カスタム生産の流れ',
      'Samples Are Free. You Only Pay Shipping.': 'サンプルは無料。送料のみご負担ください。',
      'Free sample pack': '無料サンプルパック',
      '43 sample options': '43種類のサンプル選択肢',
      'Best for B2B buyers': 'B2Bバイヤーに最適',
      'SEND SAMPLE REQUEST': 'サンプル申請を送信',
      'Submit your sample request': 'サンプル申請を送信',
      'Get a Production-Ready Custom Quote': '量産前提のカスタム見積を取得',
      'START YOUR QUOTE REQUEST': '見積依頼を開始',
      'Send artwork and quote details': 'デザインと見積条件を送信',
      'Need MOQ, Sample and Lead Time Confirmed?': 'MOQ・サンプル・納期を確認したいですか？',
      'CSTAR Buyer Download Center': 'CSTAR バイヤー向けダウンロードセンター',
      'PREVIEW ONLINE': 'オンラインで閲覧',
      'DOWNLOAD PDF': 'PDFをダウンロード',
      'Custom Heat Transfers': 'カスタム熱転写製品',
      'Custom Promotional Products': 'カスタム販促品',
      'Printable Transfers': 'プリント転写製品',
      'Custom DTF Transfers': 'カスタムDTF転写',
      'Woven Labels, Woven Badges & Brand Trims': '織ネーム・織ワッペン・ブランド副資材',
      'Leather Patches & Leather Brand Details': 'レザーパッチ・レザーブランドパーツ',
      'Your Name': 'お名前',
      'Email': 'メールアドレス',
      'Phone': '電話番号',
      'Company Website': '会社サイト',
      'Business Type': '業種',
      'Selected Sample IDs / Sample Types': '希望サンプルID / サンプル種類',
      'Your Request': 'ご要望',
      'Submit': '送信',
      'Subscribe Email': 'メール配信を受け取る',
      'Enter the sample ID': 'サンプルIDを入力',
      'Enter name': '名前を入力',
      'Enter Email': 'メールを入力',
      'Enter quantity': '数量を入力',
      'Compare Materials, Finish and MOQ Before You Quote': '見積前に素材・仕上がり・MOQを比較',
      'Final MOQ and tier pricing depend on material, artwork size, colors and quantity.': '最終MOQと段階価格は、素材・デザインサイズ・色数・数量によって決まります。'
    },
    it: {
      'CSTAR Fashion Design | Custom Rhinestone Transfers, Patches & Promotional Products': 'CSTAR Fashion Design | Transfer con strass, patch e prodotti promozionali personalizzati',
      'Rhinestone & Patch Manufacturing for Repeat B2B Orders': 'Produzione di transfer con strass e patch per ordini B2B ricorrenti',
      'UPLOAD ARTWORK & GET A QUOTE': 'CARICA GRAFICA E RICHIEDI UN PREVENTIVO',
      'Built for Buyers Who Need Clear MOQ, Sample and Lead Time': 'Pensato per buyer che hanno bisogno di MOQ, campioni e tempi chiari',
      'What CSTAR Helps You Source': 'Cosa CSTAR ti aiuta a sviluppare',
      'Real production photos buyers can quote from': 'Foto reali di produzione utili per il preventivo',
      'What to Send for a Faster Quote': 'Cosa inviare per un preventivo più rapido',
      'How Custom Production Works': 'Come funziona la produzione personalizzata',
      'Samples Are Free. You Only Pay Shipping.': 'I campioni sono gratuiti. Paghi solo la spedizione.',
      'Free sample pack': 'Kit campioni gratuito',
      '43 sample options': '43 opzioni di campione',
      'Best for B2B buyers': 'Ideale per buyer B2B',
      'SEND SAMPLE REQUEST': 'INVIA RICHIESTA CAMPIONI',
      'Submit your sample request': 'Invia la tua richiesta campioni',
      'Get a Production-Ready Custom Quote': 'Ottieni un preventivo personalizzato pronto per la produzione',
      'START YOUR QUOTE REQUEST': 'INIZIA LA RICHIESTA DI PREVENTIVO',
      'Send artwork and quote details': 'Invia grafica e dettagli del preventivo',
      'Need MOQ, Sample and Lead Time Confirmed?': 'Hai bisogno di confermare MOQ, campioni e tempi?',
      'CSTAR Buyer Download Center': 'Centro download CSTAR per buyer',
      'PREVIEW ONLINE': 'ANTEPRIMA ONLINE',
      'DOWNLOAD PDF': 'SCARICA PDF',
      'Custom Heat Transfers': 'Transfer termici personalizzati',
      'Custom Promotional Products': 'Prodotti promozionali personalizzati',
      'Printable Transfers': 'Transfer stampabili',
      'Custom DTF Transfers': 'Transfer DTF personalizzati',
      'Woven Labels, Woven Badges & Brand Trims': 'Etichette tessute, badge tessuti e accessori brand',
      'Leather Patches & Leather Brand Details': 'Patch in pelle e dettagli brand in pelle',
      'Your Name': 'Il tuo nome',
      'Email': 'Email',
      'Phone': 'Telefono',
      'Company Website': 'Sito aziendale',
      'Business Type': 'Tipo di attività',
      'Selected Sample IDs / Sample Types': 'ID campioni / tipi di campione selezionati',
      'Your Request': 'La tua richiesta',
      'Submit': 'Invia',
      'Subscribe Email': 'Iscriviti alle email',
      'Enter the sample ID': 'Inserisci l’ID campione',
      'Enter name': 'Inserisci il nome',
      'Enter Email': 'Inserisci l’email',
      'Enter quantity': 'Inserisci la quantità',
      'Compare Materials, Finish and MOQ Before You Quote': 'Confronta materiali, finitura e MOQ prima del preventivo',
      'Final MOQ and tier pricing depend on material, artwork size, colors and quantity.': 'MOQ finale e prezzi a scaglioni dipendono da materiale, dimensione grafica, colori e quantità.'
    }
  };

  const supplementalTranslations = {
    de: {
      'Overview & Route Guide': 'Überblick & Routenleitfaden',
      'Hot Fix Rhinestone Transfers': 'Hot-Fix-Rhinestone-Transfers',
      'Hot Fix Nailhead Transfers': 'Hot-Fix-Nailhead-Transfers',
      'Rhinestud & Dome Stud Transfers': 'Rhinestud- & Dome-Stud-Transfers',
      'Sequin Decoration': 'Pailletten-Dekoration',
      'Glitter Transfer Material': 'Glitter-Transfermaterial',
      'Flock Transfer Material': 'Flock-Transfermaterial',
      'PU Transfer Material': 'PU-Transfermaterial',
      'Foil & Stretchable Foil': 'Folie & Stretch-Folie',
      'Fabric & Soft-Structure Materials': 'Stoff- & Soft-Structure-Materialien',
      '3D Puff Transfer Materials': '3D-Puff-Transfermaterialien',
      'Keychains & Event Giveaways': 'Schlüsselanhänger & Event-Giveaways',
      'Special-Effect Stickers & Decals': 'Effekt-Sticker & Decals',
      'Pins, Badges & Gift Accessories': 'Pins, Badges & Geschenkaccessoires',
      'Sequin Apparel & Sparkle Merch': 'Pailletten-Bekleidung & Sparkle-Merch',
      'Cup Sleeves & Event Support': 'Cup Sleeves & Event-Support',
      'Search': 'Suche'
    },
    fr: {
      'Overview & Route Guide': 'Vue d’ensemble & guide des solutions',
      'Hot Fix Rhinestone Transfers': 'Transferts rhinestones hot fix',
      'Hot Fix Nailhead Transfers': 'Transferts nailhead hot fix',
      'Rhinestud & Dome Stud Transfers': 'Transferts rhinestud & dome stud',
      'Sequin Decoration': 'Décoration à sequins',
      'Glitter Transfer Material': 'Matière glitter transfert',
      'Flock Transfer Material': 'Matière flock transfert',
      'PU Transfer Material': 'Matière PU transfert',
      'Foil & Stretchable Foil': 'Foil & foil extensible',
      'Fabric & Soft-Structure Materials': 'Matières textile & structure souple',
      '3D Puff Transfer Materials': 'Matières transfert 3D puff',
      'Keychains & Event Giveaways': 'Porte-clés & cadeaux événementiels',
      'Special-Effect Stickers & Decals': 'Autocollants & décals à effet spécial',
      'Pins, Badges & Gift Accessories': 'Pins, badges & accessoires cadeaux',
      'Sequin Apparel & Sparkle Merch': 'Vêtements à sequins & merch scintillant',
      'Cup Sleeves & Event Support': 'Manchons de gobelet & support événementiel',
      'Search': 'Recherche',
      'Product Catalog': 'Catalogue produits',
      'Get Free Sample': 'Obtenir un échantillon gratuit',
      'Request a Custom Quote for Transfers, Patches & Promotional Products': 'Demander un devis sur mesure pour transferts, patchs et produits promotionnels',
      'Request a Custom Quote for Transfers, Patches & Promotional Products – CSTAR Fashion Design': 'Demander un devis sur mesure pour transferts, patchs et produits promotionnels – CSTAR Fashion Design',
      'Free Sample Pack for Custom Transfers, Patches & Labels': 'Kit d’échantillons gratuit pour transferts, patchs et labels sur mesure',
      'Free Sample Pack for Custom Transfers, Patches & Labels – CSTAR Fashion Design': 'Kit d’échantillons gratuit pour transferts, patchs et labels sur mesure – CSTAR Fashion Design',
      'Upload your artwork or describe your project. To help us quote accurately, please include product type, size, quantity, target delivery date, target price, shipping country and how often you expect to reorder.': 'Téléchargez votre visuel ou décrivez votre projet. Pour établir un devis précis, merci d’indiquer le type de produit, la taille, la quantité, la date de livraison souhaitée, le prix cible, le pays de livraison et la fréquence de réassort prévue.',
      'Tell us the product': 'Indiquez le produit',
      '1. Tell us the product': '1. Indiquez le produit',
      'Share buying details': 'Partagez les détails d’achat',
      '2. Share buying details': '2. Partagez les détails d’achat',
      'Attach or link artwork': 'Joignez ou liez le visuel',
      '3. Attach or link artwork': '3. Joignez ou liez le visuel',
      'We reply with next steps': 'Nous répondons avec les prochaines étapes',
      '4. We reply with next steps': '4. Nous répondons avec les prochaines étapes',
      'Rhinestone transfer, embroidered patch, silicone patch, TPU patch, woven label, leather patch or other decoration.': 'Transfert rhinestones, patch brodé, patch silicone, patch TPU, étiquette tissée, patch cuir ou autre décoration.',
      'Estimated quantity, target price, delivery deadline, shipping country and whether this is repeat purchasing.': 'Quantité estimée, prix cible, date limite de livraison, pays de destination et indication s’il s’agit d’un achat récurrent.',
      'Vector files are best, but a clear logo, sketch or reference photo also helps us start.': 'Les fichiers vectoriels sont idéaux, mais un logo net, un croquis ou une photo de référence nous aide aussi à démarrer.',
      'Material recommendation, MOQ/tier price, sample option, lead time and required production details.': 'Recommandation matière, MOQ / prix par palier, option d’échantillon, délai et détails de production requis.',
      'The form below uses your dedicated ECF inquiry form with quantity, delivery window, request details and file upload.': 'Le formulaire ci-dessous utilise votre formulaire ECF dédié avec quantité, délai souhaité, détails de demande et téléversement de fichier.',
      'Use the CSTAR sample pack to compare real material, texture, backing and finish before bulk production. This page now includes 43 sample options across rhinestone, patch, label, leather, silicone, TPU and printable routes.': 'Utilisez le pack d’échantillons CSTAR pour comparer le matériau réel, la texture, le support et la finition avant la production en série. Cette page comprend désormais 43 options d’échantillons couvrant rhinestones, patchs, labels, cuir, silicone, TPU et solutions imprimables.',
      'Shipping options: use your own courier account for freight collect, or prepay $49 for international shipping.': 'Options d’expédition : utilisez votre propre compte transporteur en port dû, ou prépayez 49 $ pour l’expédition internationale.',
      'Shipping options:': 'Options d’expédition :',
      'use your own courier account for freight collect, or prepay $49 for international shipping. The $49 fee is for the sample pack only and is not deductible from future orders.': 'utilisez votre propre compte transporteur en port dû, ou prépayez 49 $ pour l’expédition internationale. Les 49 $ couvrent uniquement l’envoi du pack d’échantillons et ne sont pas déductibles des commandes futures.',
      'The $49 fee is for the sample pack only and is not deductible from future orders.': 'Les 49 $ couvrent uniquement l’envoi du pack d’échantillons et ne sont pas déductibles des commandes futures.',
      'No sample charge. Only the shipping method is billed.': 'Aucun coût d’échantillon. Seul le mode d’expédition est facturé.',
      'Choose by material, finish, texture or patch construction.': 'Choisissez selon le matériau, la finition, la texture ou la construction du patch.',
      'Brands, print shops, embroidery factories, teams, schools and promo buyers.': 'Marques, ateliers d’impression, usines de broderie, équipes, écoles et acheteurs promotionnels.',
      'What you can compare': 'Ce que vous pouvez comparer',
      'Shipping choices': 'Choix d’expédition',
      'What to send': 'Ce qu’il faut envoyer',
      'What happens next': 'Étapes suivantes',
      'Material handfeel, sparkle level, patch texture, label detail, surface effect and production finish before quoting.': 'Toucher matière, niveau de brillance, texture du patch, finesse du label, effet de surface et finition de production avant devis.',
      'Use your own courier account for freight collect, or prepay $49 for international shipping.': 'Utilisez votre propre compte transporteur en port dû, ou prépayez 49 $ pour l’expédition internationale.',
      'Tell us the sample IDs, preferred finish, country, target date and artwork if you already have it.': 'Indiquez les IDs d’échantillons, la finition souhaitée, le pays, la date cible et le visuel si vous l’avez déjà.',
      'After you review the samples, CSTAR can recommend the right route and prepare a custom quote or proof.': 'Après examen des échantillons, CSTAR peut recommander la bonne solution et préparer un devis ou une maquette.',
      '43 Sample Options by Material & Effect': '43 options d’échantillons par matériau et effet',
      'Choose the sample IDs that look closest to the finish, texture or construction you want.': 'Choisissez les IDs d’échantillons les plus proches de la finition, de la texture ou de la construction souhaitée.',
      'If you are not sure which route fits best, describe the effect and CSTAR will recommend the right sample set.': 'Si vous n’êtes pas sûr de la solution la plus adaptée, décrivez l’effet recherché et CSTAR recommandera le bon ensemble d’échantillons.',
      'Choose the sample IDs that look closest to the finish, texture or construction you want. If you are not sure which route fits best, describe the effect and CSTAR will recommend the right sample set.': 'Choisissez les IDs d’échantillons les plus proches de la finition, de la texture ou de la construction souhaitée. Si vous n’êtes pas sûr de la solution la plus adaptée, décrivez l’effet recherché et CSTAR recommandera le bon ensemble d’échantillons.',
      'Your Email': 'Votre e-mail',
      'Enter url': 'Saisir l’URL',
      'Your Business Type': 'Votre type d’activité',
      'Fashion Brand': 'Marque de mode',
      'Appearel Manufacturer': 'Fabricant de vêtements',
      'Screen Printing': 'Sérigraphie',
      'DTF Printing': 'Impression DTF',
      'Embroidery': 'Broderie',
      'Team Dealer': 'Revendeur équipe',
      'School': 'École',
      'Government/Army': 'Gouvernement / armée',
      'Amusement Park': 'Parc d’attractions',
      'Party Supplies': 'Articles de fête',
      'Souvenir Shop': 'Boutique souvenir',
      'Community Store': 'Magasin communautaire',
      'Online Store': 'Boutique en ligne',
      'Promotional Gifts': 'Cadeaux promotionnels',
      'Sports Goods': 'Articles de sport',
      'Rhinestone': 'Rhinestone',
      'Tshirt': 'T-shirt',
      'Personal': 'Personnel',
      'Others': 'Autres',
      'Quantity-Min From 24 Pieces': 'Quantité minimale à partir de 24 pièces',
      'How soon do you need them': 'Quand en avez-vous besoin ?',
      'No time requirement': 'Pas d’exigence de délai',
      'Within 7 days': 'Sous 7 jours',
      '7-15 days': '7 à 15 jours',
      '1 month': '1 mois',
      '1-3 months': '1 à 3 mois',
      '3-6 months': '3 à 6 mois',
      'Any information provided will help determine the price，such as size, color, materials or other special need.': 'Toute information fournie aidera à déterminer le prix, comme la taille, la couleur, les matériaux ou d’autres besoins spécifiques.',
      'Upload your file if you want to customize design/logo': 'Téléversez votre fichier si vous souhaitez personnaliser un design / logo',
      'eg. +1 (123) 456-7890': 'ex. +1 (123) 456-7890'
    },
    es: {
      'Overview & Route Guide': 'Resumen y guía de rutas',
      'Hot Fix Rhinestone Transfers': 'Transfers hot fix de rhinestones',
      'Hot Fix Nailhead Transfers': 'Transfers hot fix de nailhead',
      'Rhinestud & Dome Stud Transfers': 'Transfers de rhinestud y dome stud',
      'Sequin Decoration': 'Decoración con lentejuelas',
      'Glitter Transfer Material': 'Material transfer glitter',
      'Flock Transfer Material': 'Material transfer flock',
      'PU Transfer Material': 'Material transfer PU',
      'Foil & Stretchable Foil': 'Foil y foil elástico',
      'Fabric & Soft-Structure Materials': 'Materiales textiles y de estructura suave',
      '3D Puff Transfer Materials': 'Materiales transfer 3D puff',
      'Keychains & Event Giveaways': 'Llaveros y regalos para eventos',
      'Special-Effect Stickers & Decals': 'Stickers y calcomanías de efecto especial',
      'Pins, Badges & Gift Accessories': 'Pines, insignias y accesorios de regalo',
      'Sequin Apparel & Sparkle Merch': 'Ropa de lentejuelas y merch brillante',
      'Cup Sleeves & Event Support': 'Fundas para vasos y apoyo para eventos',
      'Search': 'Buscar',
      'Product Catalog': 'Catálogo de productos',
      'Get Free Sample': 'Obtenga una muestra gratuita',
      'Request a Custom Quote for Transfers, Patches & Promotional Products': 'Solicite una cotización personalizada para transfers, parches y productos promocionales',
      'Request a Custom Quote for Transfers, Patches & Promotional Products – CSTAR Fashion Design': 'Solicite una cotización personalizada para transfers, parches y productos promocionales – CSTAR Fashion Design',
      'Free Sample Pack for Custom Transfers, Patches & Labels': 'Paquete de muestras gratis para transfers, parches y etiquetas personalizados',
      'Free Sample Pack for Custom Transfers, Patches & Labels – CSTAR Fashion Design': 'Paquete de muestras gratis para transfers, parches y etiquetas personalizados – CSTAR Fashion Design',
      'Upload your artwork or describe your project. To help us quote accurately, please include product type, size, quantity, target delivery date, target price, shipping country and how often you expect to reorder.': 'Suba su diseño o describa su proyecto. Para cotizar con precisión, incluya tipo de producto, tamaño, cantidad, fecha objetivo de entrega, precio objetivo, país de envío y la frecuencia con la que espera volver a pedir.',
      'Tell us the product': 'Indíquenos el producto',
      '1. Tell us the product': '1. Indíquenos el producto',
      'Share buying details': 'Comparta los detalles de compra',
      '2. Share buying details': '2. Comparta los detalles de compra',
      'Attach or link artwork': 'Adjunte o enlace el diseño',
      '3. Attach or link artwork': '3. Adjunte o enlace el diseño',
      'We reply with next steps': 'Respondemos con los siguientes pasos',
      '4. We reply with next steps': '4. Respondemos con los siguientes pasos',
      'Rhinestone transfer, embroidered patch, silicone patch, TPU patch, woven label, leather patch or other decoration.': 'Transfer de rhinestones, parche bordado, parche de silicona, parche de TPU, etiqueta tejida, parche de cuero u otra decoración.',
      'Estimated quantity, target price, delivery deadline, shipping country and whether this is repeat purchasing.': 'Cantidad estimada, precio objetivo, fecha límite de entrega, país de envío y si se trata de una compra repetida.',
      'Vector files are best, but a clear logo, sketch or reference photo also helps us start.': 'Los archivos vectoriales son lo mejor, pero también nos ayuda comenzar con un logo claro, un boceto o una foto de referencia.',
      'Material recommendation, MOQ/tier price, sample option, lead time and required production details.': 'Recomendación de material, MOQ / precio por escalones, opción de muestra, plazo y detalles de producción requeridos.',
      'The form below uses your dedicated ECF inquiry form with quantity, delivery window, request details and file upload.': 'El formulario de abajo utiliza su formulario ECF dedicado con cantidad, plazo de entrega, detalles de la solicitud y carga de archivos.',
      'Use the CSTAR sample pack to compare real material, texture, backing and finish before bulk production. This page now includes 43 sample options across rhinestone, patch, label, leather, silicone, TPU and printable routes.': 'Use el paquete de muestras CSTAR para comparar material real, textura, respaldo y acabado antes de la producción en volumen. Esta página ahora incluye 43 opciones de muestra entre rutas de rhinestones, parches, etiquetas, cuero, silicona, TPU e imprimibles.',
      'Shipping options: use your own courier account for freight collect, or prepay $49 for international shipping.': 'Opciones de envío: use su propia cuenta de mensajería con porte debido, o prepague 49 $ para el envío internacional.',
      'Shipping options:': 'Opciones de envío:',
      'use your own courier account for freight collect, or prepay $49 for international shipping. The $49 fee is for the sample pack only and is not deductible from future orders.': 'use su propia cuenta de mensajería con porte debido, o prepague 49 $ para el envío internacional. La tarifa de 49 $ es solo para el paquete de muestras y no es deducible de pedidos futuros.',
      'The $49 fee is for the sample pack only and is not deductible from future orders.': 'La tarifa de 49 $ es solo para el paquete de muestras y no es deducible de pedidos futuros.',
      'No sample charge. Only the shipping method is billed.': 'No hay cargo por las muestras. Solo se cobra el método de envío.',
      'Choose by material, finish, texture or patch construction.': 'Elija por material, acabado, textura o construcción del parche.',
      'Brands, print shops, embroidery factories, teams, schools and promo buyers.': 'Marcas, imprentas, fábricas de bordado, equipos, escuelas y compradores promocionales.',
      'What you can compare': 'Qué puede comparar',
      'Shipping choices': 'Opciones de envío',
      'What to send': 'Qué enviar',
      'What happens next': 'Qué sucede después',
      'Material handfeel, sparkle level, patch texture, label detail, surface effect and production finish before quoting.': 'Tacto del material, nivel de brillo, textura del parche, detalle de la etiqueta, efecto de superficie y acabado de producción antes de cotizar.',
      'Use your own courier account for freight collect, or prepay $49 for international shipping.': 'Use su propia cuenta de mensajería con porte debido, o prepague 49 $ para el envío internacional.',
      'Tell us the sample IDs, preferred finish, country, target date and artwork if you already have it.': 'Indíquenos los IDs de muestra, el acabado preferido, el país, la fecha objetivo y el diseño si ya lo tiene.',
      'After you review the samples, CSTAR can recommend the right route and prepare a custom quote or proof.': 'Después de revisar las muestras, CSTAR puede recomendar la ruta adecuada y preparar una cotización o prueba.',
      '43 Sample Options by Material & Effect': '43 opciones de muestra por material y efecto',
      'Choose the sample IDs that look closest to the finish, texture or construction you want.': 'Elija los IDs de muestra que más se acerquen al acabado, textura o construcción que desea.',
      'If you are not sure which route fits best, describe the effect and CSTAR will recommend the right sample set.': 'Si no está seguro de qué ruta encaja mejor, describa el efecto y CSTAR recomendará el conjunto de muestras adecuado.',
      'Choose the sample IDs that look closest to the finish, texture or construction you want. If you are not sure which route fits best, describe the effect and CSTAR will recommend the right sample set.': 'Elija los IDs de muestra que más se acerquen al acabado, textura o construcción que desea. Si no está seguro de qué ruta encaja mejor, describa el efecto y CSTAR recomendará el conjunto de muestras adecuado.',
      'Your Email': 'Su correo electrónico',
      'Enter url': 'Introduzca la URL',
      'Your Business Type': 'Su tipo de negocio',
      'Fashion Brand': 'Marca de moda',
      'Appearel Manufacturer': 'Fabricante de prendas',
      'Screen Printing': 'Serigrafía',
      'DTF Printing': 'Impresión DTF',
      'Embroidery': 'Bordado',
      'Team Dealer': 'Distribuidor de equipos',
      'School': 'Escuela',
      'Government/Army': 'Gobierno / ejército',
      'Amusement Park': 'Parque de atracciones',
      'Party Supplies': 'Artículos de fiesta',
      'Souvenir Shop': 'Tienda de recuerdos',
      'Community Store': 'Tienda comunitaria',
      'Online Store': 'Tienda online',
      'Promotional Gifts': 'Regalos promocionales',
      'Sports Goods': 'Artículos deportivos',
      'Rhinestone': 'Rhinestone',
      'Tshirt': 'Camiseta',
      'Personal': 'Personal',
      'Others': 'Otros',
      'Quantity-Min From 24 Pieces': 'Cantidad mínima desde 24 piezas',
      'How soon do you need them': '¿Qué tan pronto los necesita?',
      'No time requirement': 'Sin requisito de plazo',
      'Within 7 days': 'Dentro de 7 días',
      '7-15 days': '7-15 días',
      '1 month': '1 mes',
      '1-3 months': '1-3 meses',
      '3-6 months': '3-6 meses',
      'Any information provided will help determine the price，such as size, color, materials or other special need.': 'Cualquier información proporcionada ayudará a determinar el precio, como tamaño, color, materiales u otras necesidades especiales.',
      'Upload your file if you want to customize design/logo': 'Suba su archivo si desea personalizar el diseño / logo',
      'eg. +1 (123) 456-7890': 'ej. +1 (123) 456-7890'
    },
    ja: {
      'Overview & Route Guide': '概要・選び方ガイド',
      'Hot Fix Rhinestone Transfers': 'ホットフィックス ラインストーン転写',
      'Hot Fix Nailhead Transfers': 'ホットフィックス ネイルヘッド転写',
      'Rhinestud & Dome Stud Transfers': 'ラインスタッド・ドームスタッド転写',
      'Sequin Decoration': 'スパンコール装飾',
      'Glitter Transfer Material': 'グリッター転写素材',
      'Flock Transfer Material': 'フロック転写素材',
      'PU Transfer Material': 'PU転写素材',
      'Foil & Stretchable Foil': '箔・ストレッチ箔',
      'Fabric & Soft-Structure Materials': '生地系・ソフト構造素材',
      '3D Puff Transfer Materials': '3Dパフ転写素材',
      'Keychains & Event Giveaways': 'キーホルダー・イベントノベルティ',
      'Special-Effect Stickers & Decals': '特殊効果ステッカー・デカール',
      'Pins, Badges & Gift Accessories': 'ピン・バッジ・ギフトアクセサリー',
      'Sequin Apparel & Sparkle Merch': 'スパンコール衣料・きらめきグッズ',
      'Cup Sleeves & Event Support': 'カップスリーブ・イベント支援品',
      'Search': '検索'
    },
    it: {
      'Overview & Route Guide': 'Panoramica e guida percorsi',
      'Hot Fix Rhinestone Transfers': 'Transfer hot fix con strass',
      'Hot Fix Nailhead Transfers': 'Transfer hot fix nailhead',
      'Rhinestud & Dome Stud Transfers': 'Transfer rhinestud e dome stud',
      'Sequin Decoration': 'Decorazione con paillettes',
      'Glitter Transfer Material': 'Materiale transfer glitter',
      'Flock Transfer Material': 'Materiale transfer flock',
      'PU Transfer Material': 'Materiale transfer PU',
      'Foil & Stretchable Foil': 'Foil e foil elasticizzato',
      'Fabric & Soft-Structure Materials': 'Materiali tessili e a struttura morbida',
      '3D Puff Transfer Materials': 'Materiali transfer 3D puff',
      'Keychains & Event Giveaways': 'Portachiavi e omaggi evento',
      'Special-Effect Stickers & Decals': 'Sticker e decal special effect',
      'Pins, Badges & Gift Accessories': 'Pins, badge e accessori regalo',
      'Sequin Apparel & Sparkle Merch': 'Abbigliamento paillettes e merch brillante',
      'Cup Sleeves & Event Support': 'Fasce bicchiere e supporto evento',
      'Search': 'Cerca'
    }
  };

  Object.keys(supplementalTranslations).forEach((localeKey) => {
    translations[localeKey] = Object.assign({}, supplementalTranslations[localeKey], translations[localeKey] || {});
  });

  let activeLocale = pathLocale || normalizeLocale(htmlLang) || 'en';
  if (!SUPPORTED_LOCALES.includes(activeLocale)) activeLocale = 'en';

  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'OPTION']);
  const textOriginals = new WeakMap();
  const attrOriginals = new WeakMap();
  const originalDocumentTitle = document.title;

  function getDict() {
    return translations[activeLocale] || null;
  }

  function shouldTranslate() {
    return activeLocale !== 'en' && !!getDict();
  }

  function preserveWhitespace(original, translated) {
    const match = original.match(/^(\s*)([\s\S]*?)(\s*)$/);
    if (!match) return translated;
    return `${match[1]}${translated}${match[3]}`;
  }

  function rememberTextOriginal(node) {
    if (!textOriginals.has(node)) {
      textOriginals.set(node, node.nodeValue);
    }
    return textOriginals.get(node);
  }

  function translateTextNode(node) {
    if (!node || !node.nodeValue) return;
    const original = rememberTextOriginal(node);
    if (!original) return;
    const trimmed = original.trim();
    if (!trimmed) return;
    const dict = getDict();
    const translated = dict && dict[trimmed] ? dict[trimmed] : trimmed;
    node.nodeValue = preserveWhitespace(original, translated);
  }

  function rememberAttributeOriginal(el, attr) {
    let record = attrOriginals.get(el);
    if (!record) {
      record = {};
      attrOriginals.set(el, record);
    }
    if (!(attr in record)) {
      record[attr] = el.getAttribute(attr);
    }
    return record[attr];
  }

  function translateAttributes(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[placeholder],[aria-label],[title],input[type=\"submit\"],button[value]').forEach((el) => {
      ['placeholder', 'aria-label', 'title', 'value'].forEach((attr) => {
        if (!el.hasAttribute(attr)) return;
        const raw = rememberAttributeOriginal(el, attr);
        if (!raw) return;
        const trimmed = raw.trim();
        if (!trimmed) return;
        const dict = getDict();
        const translated = dict && dict[trimmed] ? dict[trimmed] : trimmed;
        el.setAttribute(attr, preserveWhitespace(raw, translated));
      });
    });
  }

  function translateRoot(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE && root !== document.body) {
      return;
    }

    if (root.nodeType === Node.ELEMENT_NODE) {
      const tagName = root.tagName;
      if (SKIP_TAGS.has(tagName)) return;
    }

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          const parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          if (SKIP_TAGS.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    let current;
    while ((current = walker.nextNode())) {
      translateTextNode(current);
    }

    translateAttributes(root);
  }

  function translateDocumentTitle() {
    const baseTitle = originalDocumentTitle.trim();
    const dict = getDict();
    if (dict && dict[baseTitle]) {
      document.title = dict[baseTitle];
    } else {
      document.title = originalDocumentTitle;
    }
  }

  function bindLanguageSelector() {
    document.querySelectorAll('[data-cstar-language-select]').forEach((select) => {
      if (select.dataset.cstarBound === 'true') return;
      select.dataset.cstarBound = 'true';
      select.addEventListener('change', (event) => {
        activeLocale = normalizeLocale(event.target.value) || 'en';
        try {
          window.localStorage.setItem('cstarLocale', activeLocale);
        } catch (error) {
          /* no-op */
        }
        run();
      });
    });
  }

  function syncLanguageSelector() {
    document.querySelectorAll('[data-cstar-language-select]').forEach((select) => {
      if (select.value !== activeLocale) {
        select.value = activeLocale;
      }
      select.setAttribute('title', LANGUAGE_LABELS[activeLocale] || 'Language');
    });
  }

  function applyLocaleMeta() {
    document.documentElement.setAttribute('data-cstar-i18n', activeLocale);
    document.documentElement.setAttribute('lang', activeLocale);
  }

  function run() {
    bindLanguageSelector();
    syncLanguageSelector();
    if (shouldTranslate()) {
      translateRoot(document.body);
      translateDocumentTitle();
    } else {
      document.title = originalDocumentTitle;
      document.documentElement.removeAttribute('data-cstar-i18n');
    }
    applyLocaleMeta();
  }

  let delayedRunsScheduled = false;

  function scheduleAsyncPasses() {
    if (!shouldTranslate() || delayedRunsScheduled) return;
    delayedRunsScheduled = true;
    [900, 2200].forEach((delay) => {
      window.setTimeout(() => {
        run();
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      run();
      scheduleAsyncPasses();
    }, { once: true });
  } else {
    run();
    scheduleAsyncPasses();
  }

  window.addEventListener('load', () => {
    run();
  }, { once: true });

  if (window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
      if (!shouldTranslate()) return;
      const hasAddedNodes = mutations.some((mutation) => mutation.addedNodes && mutation.addedNodes.length > 0);
      if (!hasAddedNodes) return;
      window.setTimeout(() => {
        run();
      }, 120);
    });

    const startObserving = () => {
      if (!document.body) return;
      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => {
        observer.disconnect();
      }, 15000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserving, { once: true });
    } else {
      startObserving();
    }
  }
})();
